import styled from 'styled-components';

import { media } from '@/shared/ui/core';

export const EmptyList = styled.div`
  width: 100%;
  max-width: 35.25rem;
  margin: 0 auto;
  position: relative;
`;

export const SectionWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding: 0 0 1.5rem;
`;

export const WrittenContent = styled.div`
  width: 100%;

  .Title {
    line-height: 1;
    height: auto;
    margin-bottom: 0.75rem;
    text-align: center;
  }

  .Text {
    margin-bottom: 1.5rem;
    display: block;
    text-align: center;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  height: auto;

>.component__button {
  height: 3.125rem;
  padding: 0.5rem;

  @media ${media.tabletMin} {
    font-size: 0.9375rem;
    max-width: 13.625rem;
    height: 2rem;
    margin: 1.5rem auto 0;
    }
  }
`;
